/**
 * Online Trafik Sigortası - API Service
 * PHP backend üzerinden sigorta.online'a SSE stream bağlantısı
 */

const API_URL = `${window.location.protocol}//${window.location.host}/api/trafik-query.php`;

/**
 * Trafik sigortası teklifi al (SSE Stream)
 * @param {Object} queryData - Form verileri
 * @param {Function} onData - Her veri geldiğinde çağrılır
 * @param {Function} onError - Hata durumunda
 * @param {Function} onComplete - Tamamlandığında
 */
export function streamTrafikQuote(queryData, onData, onError, onComplete) {
  const abortController = new AbortController();

  fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream'
    },
    body: JSON.stringify(queryData),
    signal: abortController.signal
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Sunucu hatası`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      function read() {
        reader.read().then(({ done, value }) => {
          if (done) {
            // Kalan buffer'ı işle
            if (buffer.trim()) {
              processLines(buffer, onData);
            }
            onComplete();
            return;
          }

          buffer += decoder.decode(value, { stream: true });

          // Satır satır işle
          const lines = buffer.split('\n');
          buffer = lines.pop(); // Son eksik satırı tut

          const fullText = lines.join('\n');
          processLines(fullText, onData);

          read();
        }).catch(err => {
          if (err.name !== 'AbortError') {
            onError(err);
          }
        });
      }

      read();
    })
    .catch(err => {
      if (err.name !== 'AbortError') {
        onError(err);
      }
    });

  // Abort fonksiyonu döndür (iptal için)
  return () => abortController.abort();
}

/**
 * SSE satırlarını parse et
 */
function processLines(text, onData) {
  const lines = text.split('\n');

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    let jsonStr = trimmed;
    if (jsonStr.startsWith('data: ')) {
      jsonStr = jsonStr.slice(6);
    }

    try {
      const parsed = JSON.parse(jsonStr);

      // Hata kontrolü
      if (parsed.error) {
        console.error('API Error:', parsed.error);
        return;
      }

      // Tamamlanma kontrolü
      if (parsed.completed) {
        return;
      }

      onData(parsed);
    } catch (e) {
      // Parse hatası - geç
    }
  }
}